import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
import { OrderManagementPermissions } from "@redotech/redo-model/permissions";

export const returnsProcessingAnalyticsRoutes: PermissionedRouteObject[] = [
  {
    index: true,
    handle: {
      breadcrumb: "Returns processing",
      permission: OrderManagementPermissions.VIEW_ORDER_FULFILLMENT_ANALYTICS,
    },
    async lazy() {
      const { ReturnsProcessingAnalyticsPage } = await import(
        "./returns-processing-analytics-page"
      );
      return { Component: ReturnsProcessingAnalyticsPage };
    },
  },
];
